/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressure in mmHg (torr) and temperature in °C. 1 mmHg ≈ 1.333 mbar if you need to convert from a vacuum gauge.`)
};

const es_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presión en mmHg (torr) y temperatura en °C. 1 mmHg ≈ 1.333 mbar si necesitas convertir desde un manómetro de vacío.`)
};

const de_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druck in mmHg (Torr) und Temperatur in °C. 1 mmHg ≈ 1,333 mbar, falls Sie von einer Vakuumanzeige umrechnen müssen.`)
};

const nl_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druk in mmHg (torr) en temperatuur in °C. 1 mmHg ≈ 1,333 mbar als u vanaf een vacuümmeter moet omrekenen.`)
};

const fr_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pression en mmHg (torr) et température en °C. 1 mmHg ≈ 1,333 mbar si vous devez convertir depuis une jauge à vide.`)
};

const it_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressione in mmHg (torr) e temperatura in °C. 1 mmHg ≈ 1,333 mbar se devi convertire da un manometro a vuoto.`)
};

const pt_br2_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão em mmHg (torr) e temperatura em °C. 1 mmHg ≈ 1,333 mbar, caso você precise converter a partir de um manômetro de vácuo.`)
};

const pt_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão em mmHg (torr) e temperatura em °C. 1 mmHg ≈ 1,333 mbar, caso precise de converter a partir de um manómetro de vácuo.`)
};

const ja_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧力はmmHg(torr)、温度は°Cです。真空計から換算する場合、1 mmHg ≈ 1.333 mbarです。`)
};

const zh_bp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压力单位为 mmHg（torr），温度单位为 °C。若需从真空计换算，1 mmHg ≈ 1.333 mbar。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_faq_a4", locale)
	if (locale === "en") return en_bp_faq_a4(inputs)
	if (locale === "es") return es_bp_faq_a4(inputs)
	if (locale === "de") return de_bp_faq_a4(inputs)
	if (locale === "nl") return nl_bp_faq_a4(inputs)
	if (locale === "fr") return fr_bp_faq_a4(inputs)
	if (locale === "it") return it_bp_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_bp_faq_a4(inputs)
	if (locale === "pt") return pt_bp_faq_a4(inputs)
	if (locale === "ja") return ja_bp_faq_a4(inputs)
	return zh_bp_faq_a4(inputs)
};